import moment from 'moment'
import * as Redux from 'redux'
import * as App from '../../app'
import * as Actions from '../../components/form'
import * as IsActive from '../../components/is_active'
import * as Pager from '../../components/pager'
import * as Sortable from '../../components/sortable'
import * as Request from '../../request'
import * as Router from '../../router'
import * as Constants from './constants'
import * as Types from './types'
import * as Utils from './utils'

const initialDataState: Types.ComponentDataState = {
  domains: [],
  filteredDomains: [],
  search: null,
  validationStatus: Constants.ALL,
}

const initialViewState: Sortable.SortableViewState = {
  isLoading: false,
  sort: [],
}

const initialModalState: Types.ComponentModalState = {
  cnames: null,
  displayResponse: false,
  domain: '',
  isOpen: false,
  isSubmitting: false,
}

type AllActions = Redux.Action &
                  Request.SuccessAction &
                  IsActive.FilterActionObject &
                  App.UrlParsedAction<{filter: string}> &
                  Actions.Actions<{value: string}>

const normalizeTypes = (payload: Types.Domain[]): Types.Domain[] => {
  return payload.map((e: Types.Domain) => ({
    ...e,
    date_validation: e.date_validation ? moment(e.date_validation) : '',
  }))
}

const dataReducer = (state: Types.ComponentDataState = initialDataState, action: AllActions) => {
  switch (action.type) {
    case Request.successConstant(Constants.FETCH_DOMAINS):
      return {
        ...state,
        domains: normalizeTypes(action.payload.response),
        filteredDomains: Utils.filterGrid(normalizeTypes(action.payload.response), state.validationStatus.value),
      }
    case Request.successConstant(Constants.VERIFY_DOMAIN):
      return {
        ...state,
        domains: Utils.changeDomainStatus(state.domains,
                                          action.payload.response.results.id,
                                          action.payload.response.results.valid ?
                                            Constants.VERIFIED.value : Constants.FAILED.value),
        filteredDomains: Utils.changeDomainStatus(state.filteredDomains,
                                                  action.payload.response.results.id,
                                                  action.payload.response.results.valid ?
                                                    Constants.VERIFIED.value : Constants.FAILED.value),
      }
    case Request.successConstant(Constants.DELETE_DOMAIN):
      return {
        ...state,
        domains: Utils.changeDomainStatus(state.domains, action.payload.response.results.id, Constants.DELETED.value),
        filteredDomains: Utils.changeDomainStatus(state.filteredDomains,
                                                  action.payload.response.results.id, Constants.DELETED.value),
      }
    case App.URL_PARSED:
      return {
        ...state,
        validationStatus: Utils.setFilterAfterUrl(action.params.filter) || state.validationStatus,
      }
    case Router.ON_ENTER:
      return {
        ...state,
        search: null,
      }
    default:
      return state
  }
}

const filterReducer = (state: Types.ComponentDataState, action: AllActions) => {
  switch (action.type) {
    case IsActive.filterStatusConstant(Constants.CHANGE_VALIDATON_STATUS):
      return {
        ...state,
        filteredDomains: Utils.filterGrid(state.domains, action.filter.value),
        validationStatus: action.filter,
      }
    case Constants.SEARCH_INPUT:
      return {
        ...state,
        search: action.value,
      }
    default:
      return state
  }
}

export const modalReducer = (state: Types.ComponentModalState = initialModalState, action: AllActions) => {
  switch (action.type) {
    case Constants.ADD_DOMAIN:
      return {
        ...state,
        isOpen: true,
      }
    case Constants.CLOSE_MODAL:
      return {
        ...state,
        displayResponse: false,
        domain: '',
        isOpen: false,
      }
    case Constants.EDIT_DOMAIN:
      return {
        ...state,
        displayResponse: false,
        domain: action.value,
      }
    case Request.requestConstant(Constants.SUBMIT_NEW_DOMAIN):
      return {
        ...state,
        isSubmitting: true,
      }
    case Request.successConstant(Constants.SUBMIT_NEW_DOMAIN):
      return {
        ...state,
        cnames: action.payload.response.dns,
        isSubmitting: false,
      }
    case Constants.DOMAIN_CREATED:
      return {
        ...state,
        displayResponse: true,
        isSubmitting: false,
      }
    default:
        return state
  }
}

export const sortReducer = (event: Sortable.ReducerEvent<Sortable.SortableObject>) =>
  (state: Types.ComponentDataState, action: Sortable.SortAction) => {
  switch (action.type) {
    case Sortable.sortTableConstant(event.requestEvent):
    case Sortable.sortTableConstant(event.sortEvent):
      return {
        ...state,
        filteredDomains: Sortable.sortState(state.filteredDomains, action.options.value),
      }
    default:
      return state
  }
}

const sortReducerEvent: Sortable.ReducerEvent<Types.Domain> = {
  defaultSort: {field: 'domains', dir: 'asc'},
  normalizer: normalizeTypes,
  requestEvent: Constants.FETCH_DOMAINS,
}

export const reducer = Redux.combineReducers({
  data: Request.reducerChain([filterReducer, dataReducer, sortReducer(sortReducerEvent)]),
  modal: modalReducer,
  page: Pager.createReducer(Constants.FETCH_DOMAINS),
  view: Request.reducerChain([IsActive.filterReducer(Sortable.viewReducer(sortReducerEvent),
        Constants.FETCH_DOMAINS, initialViewState),
        ]),
})



// WEBPACK FOOTER //
// ./src/pages/domain-authentication/reducer.tsx